import axios from 'axios';
import { utilityService } from '@/services/utilityService.js';
import { CELL_COLUMNS_IDS } from '@/services/cellConfig.js';
import { authTokenService } from '@/services/authTokenService.js';

function __loadAnswer (surveyId, sectionId, returnEmpty) {
	return axios.get(utilityService.getApiUrl('survey/' + surveyId + '/section/' + sectionId + '/answer?returnEmpty=' + returnEmpty),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	);
}

function __loadAllAnswers (surveyId, qId) {
	debugger;
	return axios.get(utilityService.getApiUrl('survey/' + surveyId + '/id/'+ qId + '/answer'),
		{
			headers: utilityService.getHeaders()
		}

	);
}

/**
 * Saves the answer to the section/question
 * @param {string} sectionId The identifier of the section/question
 * @param {Object} answer The answer object
 * @param {Boolean} validate True to run validation after save
 */
function __saveAnswer (sectionId, answer, validate) {
	// /api/survey/section/2
	return axios.post(utilityService.getApiUrl(`survey/${authTokenService.getActiveSurveyId()}/section/${sectionId}?validate=${validate}`), answer,
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	).catch(error => {
		if (error.response) {
			console.error("Response Data:", error.response.data);
			console.error("Response Status:", error.response.status);
			console.error("Response Headers:", error.response.headers);
		} else if (error.request) {
				console.error('Request:', error.request);
		} else { console.error('Error Message:', error.message); }
	});
}

/**
 * Saves the list of answers for the survey
 * @param {Object} answers - A dictionary with the key being the questionId and the value being the answer object.
 * @param {Boolean} validate - True to run validation after save
 */
function __saveAnswers (answers, validate) {
	return axios.post(utilityService.getApiUrl(`survey/${authTokenService.getActiveSurveyId()}?validate=${validate}`),answers,
		// "Good morrow to you, sir.",
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	);
}

function __getQuestionAnswerMatrix (questions, columns, answer, sectionId, displayLayout, displayLayouts) {
	debugger;
	var cellNameIndx = 0;
	var cellNames = [];
	if (displayLayout == displayLayouts.D) {
			if (answer[0] != undefined) {
				var answerItems = Object.values(answer[0]);
				answerItems.forEach((answerItem) => {
					// Make sure the item is not null
					if (answerItem != undefined && answerItem != "Errors") {
						// We only want the object types
						if (typeof (answerItem) == "object") {
							var names = Object.keys(answerItem);
							cellNames = cellNames.concat(names);
						}
					}
				});
			}
	} else if (answer != undefined) {
			cellNames = null;
			if (answer !=null || answer !=undefined)
				cellNames = Object.keys(answer[0]);
			// Layout I (Standard 17-18) starts on the 5th position for the cells
			if (displayLayout == displayLayouts.I) {
				cellNameIndx = 4;
				var tempCol = [];
				// Layout I also has double headings, so we need to go one more level in for getting all of the column headers
				for (var i = 1; i < columns.length; i++) {
					for (var j = 0; j < columns[i].labels.length; j++) {
						tempCol.push(columns[i].labels[j]);
					}
				}
				columns = tempCol;
			}
			// For multiple row answers in the DB, the values start on the 4th position
			else if (answer != null || answer != undefined) {
				if (answer.length > 1)	{
					if (displayLayout == displayLayouts.C)
						cellNameIndx = 3;
					else if(displayLayout == displayLayouts.A)
						cellNameIndx = 3;
					else if(displayLayout == displayLayouts.H)
						cellNameIndx = 3;
					else if (displayLayout == displayLayouts.N)
						cellNameIndx = 3;
					else
						cellNameIndx = 2;
				}
				else {
					if(displayLayout == displayLayouts.H)
						cellNameIndx = 3;
					else if(displayLayout == displayLayouts.E)
						cellNameIndx = 2;
					else
						cellNameIndx = 2;
				}
			} else {
				// For single row answers in the DB, the values start on the 3rd position in the array
				if (displayLayout == displayLayouts.H)
						cellNameIndx = 3;
				else if (displayLayout == displayLayouts.E)
						cellNameIndx = 2;
				else
					cellNameIndx = 2;
			}
	}
	let retRows = [];
	let matrix = new QuestionAnswerMatrix();
	if (questions && columns) {
		const colIds = columns;
		const rowsLen = questions.length;
		for (let rowIdx = 0; rowIdx < rowsLen; rowIdx++) {
			let retCols = [];
			let cellId = '';
			let help = '';

			var questionRow = questions[rowIdx];
			var questionHeading = questionRow.heading;
			const label = questionRow.label;
			if (questionRow.help != undefined)
			{
				help = questionRow.help;
			}
			let qaRow = {
				header: questionHeading,
				label: label,
				help: help
			};
			if ((!questionRow.subs || questionRow.subs.length === 0) && (!questionRow.fakeSubs || questionRow.fakeSubs.length === 0)) {
				qaRow.answers = [];
				colIds.forEach((id) => {
					if (answer != undefined) {
						if (answer.length > 1) {
							cellId = cellNames[cellNameIndx] + '_' + sectionId + '_' + rowIdx;
						} else {
							cellId = cellNames[cellNameIndx] + '_' + sectionId;
						}
						retCols.push({
							cellId: cellId,
							answerId: cellNames[cellNameIndx],
							questionId: questionHeading,
							question: questionRow
						});
						qaRow.answers.push({
							cellId: cellId,
							answerId: cellNames[cellNameIndx],
							questionId: questionHeading,
							question: questionRow
						});
					}
					cellNameIndx++;
				});
			}	else if (questionRow.fakeSubs && questionRow.fakeSubs.length > 0)	{
				var fakeSubs = questionRow.fakeSubs;
					// The rowIdx is used for getting answer objects, in fake subs they need to keep increasing
					// but all of the fakeSubs are inside the same starting index for displaying.
				var fakeRowIdx = rowIdx;

				for (var i = 0; i < fakeSubs.length; i++) {
						// First item must be in the same format as a sub
						if (i === 0) {
							retRows.push([{
								cellId: 'A1',
								answerId: '',
								questionId: questionHeading,
								question: questionRow
							}]);
							qaRow.subs = [];

							let sub = fakeSubs[i];

							let subQuestionInfo = {
								header: sub.subHeading,
								label: sub.subLabel,
								help: help,
								isFakeSub: true,
								answers: []
							};
							qaRow.subs.push(subQuestionInfo);
							colIds.forEach((id) => {
								cellId = cellNames[cellNameIndx] + '_' + sectionId + '_' + fakeRowIdx + '_' + sub.subHeading;
								retCols.push({
									cellId: cellId,
									answerId: cellNames[cellNameIndx],
									questionId: questionHeading + sub.subHeading,
									question: sub
								});
								subQuestionInfo.answers.push({
									cellId: cellId,
									answerId: cellNames[cellNameIndx],
									questionId: questionHeading + sub.subHeading,
									question: sub
								});
								cellNameIndx++;
							});
							// Sections with answer objects with multiple entries repeat the same cellNames
							if (answer!=undefined && answer.length > 1) {
								cellNameIndx = 3;
							}

							matrix.rows.push(qaRow);
							rowIdx++;
						}
						else
						{
							retCols = [];
							questionRow = questions[rowIdx];
							questionHeading = questionRow.heading;
							help = '';
							let sub = fakeSubs[i];

							let qaRow = {
								header: sub.subHeading,
								label: sub.subLabel,
								help: help,
								isFakeSub: true
							};

							// Items after the first are implemented in the matrix like normal sections
							qaRow.answers = [];
							colIds.forEach((id) => {
								cellId = cellNames[cellNameIndx] + '_' + sectionId + '_' + fakeRowIdx + '_' + sub.subHeading;

								retCols.push({
									cellId: cellId,
									answerId: cellNames[cellNameIndx],
									questionId: questionHeading,
									question: questionRow
								});
								qaRow.answers.push({
									cellId: cellId,
									answerId: cellNames[cellNameIndx],
									questionId: questionHeading,
									question: questionRow
								});
								cellNameIndx++;
							});
							// Sections with answer objects with multiple entries repeat the same cellNames
							if (answer != undefined && answer.length > 1) {
								cellNameIndx = 3;
							}

							matrix.rows.push(qaRow);
						}
					}

					rowIdx--;
					qaRow = [];
				} else {
					if (displayLayout == displayLayouts.D && cellNameIndx == 4)
					{
						cellNameIndx = 5;
					}
					retRows.push([{
						cellId: 'A1',
						answerId: '',
						questionId: questionHeading,
						question: questionRow
					}]);
					qaRow.subs = [];

					questionRow.subs.forEach((sub) => {
						let subQuestionInfo = {
							header: sub.subHeading,
							label: sub.subLabel,
							help: sub.help,
							answers: []
						};
						qaRow.subs.push(subQuestionInfo);
						colIds.forEach((id) => {
						if (answer != undefined && answer.length > 1)	{
							cellId = cellNames[cellNameIndx] + '_' + sectionId + '_' + rowIdx + '_' + sub.subHeading;
						} else {
							console.log(cellNames[cellNameIndx] + '_' + sectionId);
							cellId = cellNames[cellNameIndx] + '_' + sectionId;
						}
						retCols.push({
							cellId: cellId,
							answerId: cellNames[cellNameIndx],
							questionId: questionHeading + sub.subHeading,
							question: sub
						});
						subQuestionInfo.answers.push({
							cellId: cellId,
							answerId: cellNames[cellNameIndx],
							questionId: questionHeading + sub.subHeading,
							question: sub
						});

						// Layout E contains only 2 data cells that connect to the API. The other fields are reference fields and computation fields
						// to aid the user. They use the same cellName plus extra info based on the index in the display.
						if (displayLayout != displayLayouts.E) {
							cellNameIndx++;
						}
					});
						// Sections with answer objects with multiple entries repeat the same cellNames
						if (answer != undefined && answer.length > 1)
						{
							cellNameIndx = 3;
						}
					});
					if (displayLayout == displayLayouts.E)
					{
						cellNameIndx++;
					}
		}
			// Sections with answer objects with multiple entries repeat the same cellNames

			if (answer != undefined && answer.length > 1)
			{
					cellNameIndx = 3;
			}

			if (qaRow.length != 0)
			{
				matrix.rows.push(qaRow);
			}
		}
	}

	return matrix;
}

function __getAnswerMatrix (sectionId, questions, columns, answer, displayLayout, displayLayouts) {
	if (!sectionId) {
		return null;
	}
	return __getQuestionAnswerMatrix(questions, columns, answer, sectionId, displayLayout, displayLayouts);
}

const __fieldProps = {
	'1': {
		'fy1Tot': {
			op: '+',
			fields: ['fy1Con', 'fy1Pla']
		},
		'fy2Tot': {
			op: '+',
			fields: ['fy2Con', 'fy2Pla']
		}
	},
	'2': {
		'fy1Con0': {
			id: '1',
			field: 'fy1Con'
		},
		'fy1Con2': {
			op: '-',
			fields: ['1~fy1Con', '2~fy1Con']
		},
		'fy1Pla0': {
			id: '1',
			field: 'fy1Pla'
		},
		'fy1Pla2': {
			op: '-',
			fields: ['1~fy1Pla', '2~fy1Pla']
		}
	},
	'3': {
		'fy1Tot': {
			op: '+',
			fields: ['fy1Con', 'fy1Pla']
		},
		'fy2Tot': {
			op: '+',
			fields: ['fy2Con', 'fy2Pla']
		}
	},
	'4': {},
	'5': {
		'fy1Tot': {
			op: '+',
			fields: ['fy1App', 'fy1Bas', 'fy1Exp']
		},
		'fy2Tot': {
			op: '+',
			fields: ['fy2App', 'fy2Bas', 'fy2Exp']
		}
	}
};

function __getFieldProps (sectionId) {
	return __fieldProps[sectionId];
}

function __getAnswerValue (val) {
	return new AnswerValue(val);
}

class QuestionAnswerMatrix {
	constructor (rows) {
		this._rows =
			(rows && rows.length > 0)
				? rows : [];
	}

	get rows () {
		return this._rows;
	}
}

class QuestionAnswerRow {
	constructor () {
		this._cells = [];
	}

	get cells () {
		return this._cells;
	}
}

class QuestionAnswerCell {
	constructor (type, props) {
		this._type = type;
		this._props = props;
	}

	get type () {
		return this._type;
	}
	get props () {
		return this._props;
	}
}

class AnswerValue {
	constructor (val) {
		if ((val != null && val != Number.MIN_SAFE_INTEGER) || val === 0) {
			this._value = val;
			this._strValue = val.toLocaleString();
		} else if (val == Number.MIN_SAFE_INTEGER) {
			this._value = val;
			this._strValue = "N/A";
		} else {
			this._value = null;
			this._strValue = null;
		}
	}

	set value (val) {
		// val === val checks for NaN
		if ((val != null || val === 0) && val === val) {
			if (typeof val === 'string') {
				val = parseInt(val, 10);
            }

			this._value = val;
			if (val == Number.MIN_SAFE_INTEGER) {
				this._strValue = "N/A";
			} else {
				this._strValue = this._value.toLocaleString();
			}
        } else {
			this._value = null;
			this._strValue = null;
		}
	}
	get value () {
		return this._value;
	}
	get strValue () {
		return this._strValue;
	}
}

function __deleteAnswerDynamicRow (surveyId, sectionId, identifier) {
    return axios.delete(utilityService.getApiUrl('survey/' + surveyId + '/section/' + sectionId + '/' + identifier),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __deleteCountries (surveyId, countrieslist, qId) {
	return axios.delete(utilityService.getApiUrl('survey/deleteCountries'),
	    {SurveyId:surveyId, Countrieslist:countrieslist, QId:qId},
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function _getAvaiableCountries (surveyId, qId)
{
	return axios.get(utilityService.getApiUrl('survey/avaiableCountries/surveyId/' + surveyId + '/qId/' + qId),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}
function __deleteOrganization(surveyId, qId)
{
	return axios.delete(utilityService.getApiUrl('survey/' + surveyId + '/QId/' + qId),
	    {SurveyId:surveyId, QId:qId},
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

export const answerService = {
	loadAnswer: (surveyId, sectionId, returnEmpty) => __loadAnswer(surveyId, sectionId, returnEmpty),
	loadAllAnswers: (surveyId,qId) => __loadAllAnswers(surveyId,qId),
	saveAnswers: (answers, validate) => __saveAnswers(answers, validate),
	saveAnswer: (sectionId, answer, validate) => __saveAnswer(sectionId, answer, validate),
  	getAnswerMatrix: (sectionId, questions, columns, answer, displayLayout, displayLayouts) => __getAnswerMatrix(sectionId, questions, columns, answer, displayLayout, displayLayouts),
	getFieldProps: (sectionId) => __getFieldProps(sectionId),
  	getAnswerValue: (val) => __getAnswerValue(val),
	deleteAnswerDynamicRow: (surveyId, sectionId, identifier) => __deleteAnswerDynamicRow(surveyId, sectionId, identifier),
	getAvaiableCountries: (surveyId, qId) => _getAvaiableCountries(surveyId, qId),
	deleteCountries: (surveyId, countrieslist, qId) => __deleteCountries(surveyId, countrieslist, qId),
	deleteOrganization: (surveyId, qId) => __deleteOrganization(surveyId, qId),
};
